<template>
  <van-form class="container" @submit="onSubmit">
    <div class="container zx-fill-ticket-info inenr-container">
      <!-- <div class="header f-s-b">
                <div class="info-image-box f-c">
                    <van-image 
                        class="info-image"
                        lazy-load
                        fit="cover"
                        src="https://img.yzcdn.cn/vant/cat.jpeg"
                    />
                    <span class="user-leave">普通用户</span>
                </div>
                <div class="user-name g-b-500">李依依</div>
                <div class="user-tips">欢迎您</div>
            </div> -->

      <div class="body">
        <ul class="body-rander-item explain-home-info-input">
          <!-- <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.name"
                            required
                            :name="`name`"
                            :border="false"
                            label="姓名"
                            placeholder="请输入用户姓名"
                            :rules="[{ required: true, message: '请正确填写用户姓名', validator: checkName }]"
                        />
                    </li> -->

          <!-- <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.id"
                            name="id"
                            required
                            :border="false"
                            label="身份证"
                            placeholder="请输入用户身份证"
                            :rules="[{ required: true, message: '请正确填写用户身份证', validator: checkId }]"
                        />
                    </li> -->

          <li class="row-box">
            <van-field
              class="item-row f-s-b user-name"
              v-model.trim="contactsInfo.oldPhone"
              required
              type="tel"
              maxlength="11"
              name="oldPhone"
              :border="false"
              label="原手机号"
              placeholder="请输入原手机号码"
              :rules="[
                {
                  required: true,
                  message: '请正确填写原手机号码',
                  validator: checkPhone,
                },
              ]"
            />
            <!-- <i class="iconfont iconjiantouarrow487 icon-size"></i> -->
          </li>
          <li class="row-box">
            <van-field
              class="item-row f-s-b user-name"
              v-model.trim="contactsInfo.newPhone"
              required
              type="tel"
              maxlength="11"
              name="newPhone"
              :border="false"
              label="新手机号"
              placeholder="请输入新手机号码"
              :rules="[
                {
                  required: true,
                  message: '请正确填写新手机号码',
                  validator: checkPhone,
                },
              ]"
            />
            <!-- <i class="iconfont iconjiantouarrow487 icon-size"></i> -->
          </li>

          <li class="row-box code-box f-c">
            <van-field
              v-model="contactsInfo.code"
              center
              clearable
              :border="false"
              maxlength="6"
              name="code"
              placeholder="请输入短信验证码"
              :rules="[
                {
                  required: true,
                  message: '请正确填写短信验证码',
                  validator: checkCode,
                },
              ]"
            />
            <div class="code-btn f-c" v-touch:tap="getCode">{{ btnTxt }}</div>
          </li>
        </ul>

        <ul class="body-rander-item"></ul>
      </div>

      <div class="foot f-c">
        <van-button class="btn f-c" block type="info" native-type="submit">
          保存
        </van-button>
      </div>

      <div hidden style="width: 0; height: 0">{{ getUserInfo }}</div>
    </div>
  </van-form>
</template>

<script>
import { Field, Form, Button } from "vant";
import http from "@js/http-zyz.js";
import {
  updateBindPhoneUrl,
  sendSMSVerifyCodeUrl,
  getUserInfoByOpenId,
} from "@url";
// import {
//     checkUserIsBindPhone,
// } from '@js/url.js';
export default {
  data() {
    return {
      phonePattern: /^1[3456789]\d{9}$/,
      idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      contactsInfo: {
        oldPhone: "",
        newPhone: "",
        code: "",
      },
      btnFlag: true,
      btnTxt: "获取验证码",
    };
  },
  created() {},
  methods: {
    onSubmit(values) {
      console.log("submit", values);
      if (values) {
        // this.$router.push({ name: 'volunteerSuccess'})
        if (this.contactsInfo.oldPhone === this.contactsInfo.newPhone) {
          this.$toast.fail("新号码与旧号码一致!");
        } else {
          var data = {
            oldPhone: this.contactsInfo.oldPhone,
            newPhone: this.contactsInfo.newPhone,
            code: this.contactsInfo.code,
          };
          this.commitData(data);
        }
      }
    },
    commitData(data) {
      http.post(updateBindPhoneUrl, data).then((res) => {
        var {
          data: { success = true, msg = "更换手机号失败" },
        } = res;
        if (success) {
          getUserInfoByOpenId(this.getOpenId);
          this.$toast.success({
            message: "更换手机号成功",
            onClose: () => {
              this.$router.go(-1);
            },
          });
        } else {
          this.$toast.fail(msg);
        }
      });
    },
    getCode() {
      if (this.phonePattern.test(this.contactsInfo.oldPhone)) {
        if (this.btnFlag) {
          this.codeBtnCount();
          this.sendCode();
        }
      } else {
        this.$toast("请正确填写手机号码");
      }
    },
    sendCode() {
      http
        .post(sendSMSVerifyCodeUrl, {
          phone: this.contactsInfo.oldPhone,
        })
        .then((res) => {
          var {
            data: {
              success = false,
              data: { verifyCode: code },
            },
          } = res;
          if (success) {
            this.$toast.success("短信发送成功 请注意查收");
          } else {
            this.$toast.fail("短信发送失败 请稍后再试");
          }
        });
    },
    codeBtnCount(size = 59) {
      this.btnFlag = false;
      var time = setInterval(() => {
        this.btnTxt = `${size}秒后重试`;
        size--;
        sessionStorage.setItem("change-phone-code-count", size);
        if (size === 0) {
          clearInterval(time);
          this.btnTxt = "获取验证码";
          this.btnFlag = true;
          sessionStorage.removeItem("change-phone-code-count");
        }
      }, 1000); //  记得改成 1000
    },
    checkName(v) {
      return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v);
      // return v === ""? false : true;
    },
    checkPhone(v) {
      return this.phonePattern.test(v);
      // return new Promise(resolve => {
      //     this.$toast.loading({
      //         forbidClick: true,
      //         message: '验证中...'
      //     });
      //     setTimeout(() => {
      //         this.$toast.clear();
      //         resolve(this.phonePattern.test(v));
      //     }, 700);
      // });
    },
    checkId(v) {
      return this.idPattern.test(v);
    },
    checkCode(v) {
      return /^[0-9]{6}$/.test(v);
    },
  },
  computed: {
    //  判断当前用户是否绑定 来对应渲染页面
    isBindUserInfo() {
      // return true;
      return this.$store.state.userInfo.isBind || false;
    },
    getOpenId() {
      return this.$store.state.userInfo.openId || "";
    },
    getUserInfo() {
      var info = this.$store.state.userInfo.info || false;
      if (info) {
        this.contactsInfo.oldPhone = info.phone;
      }
      return info;
    },
  },
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
  },
};
</script>

<style lang="less" scoped>
.red-box {
  border: 1px solid red;
}

.f-s-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.f-c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.inenr-container {
  padding: 7px;
}
.container {
  // height: ~"calc(100% - 50px)" !important;
  // padding-bottom: 50px;
  .header {
    padding: 20px 0;
    margin-bottom: 10px;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
    background-color: rgba(255, 255, 255, 1);
    flex-direction: column;
    font-size: 12px;
    color: #bebebe;
    .info-image-box {
      transform: translateX(30px);
      .info-image {
        width: 70px;
        height: 70px;
        border-radius: 100%;
        overflow: hidden;
      }
      .user-leave {
        margin-left: 12px;
      }
    }
    .user-name {
      font-size: 20px;
      color: #343434;
      margin: 10px 0 5px;
    }
  }

  .body {
    margin-bottom: 10px;
    // padding: 7px;
    .body-rander-item {
      background-color: #ffffff;
      overflow: hidden;
      border-radius: 5px;
      box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
      margin-bottom: 7px;
      .row-box {
        position: relative;
        box-sizing: border-box;
        height: 50px;
        padding: 0 12px;
        background-color: #ffffff;
        &:last-child {
          .item-row {
            border: 0;
          }
        }
        .icon-size {
          font-weight: 500;
          color: #9599a2;
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
        .item-row {
          border-bottom: 0.5px solid #cbcbcb;
          height: 100%;
          background-color: transparent;
          font-size: 14px;
        }
        .right-control {
          color: #9599a2;
          position: absolute;
          top: 50%;
          overflow: hidden;
          transform: translateY(-50%);
          left: 90px;
          right: 12px;
          .icon-size {
            &::before {
              font-weight: 500;
            }
          }
        }
        .number-control {
          justify-content: flex-start;
          .number-box {
            margin: 0 10px;
            display: inline-flex;
            vertical-align: top;
            width: 65px;
            height: 22px;
            box-sizing: border-box;
            border: 1px solid rgba(212, 212, 212, 1);
          }
          .number-icon-size {
            &::before {
              font-size: 20px;
              font-weight: 500;
            }
          }
        }
      }
      .code-box {
        padding-left: 90px;
        .code-btn {
          width: 84px;
          height: 23px;
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          font-size: 13px;
          color: #9aa2b7;
          border-radius: 11px;
          background-color: #ffffff;
          border: 1px solid rgba(213, 213, 213, 1);
        }
      }
      .info-row {
        padding-top: 10px;
        padding-bottom: 10px;
        align-items: baseline;
        height: auto;
        justify-content: flex-start;
        font-size: 12px;
        color: #979899;
        .left-txt {
          margin-left: 12px;
          width: 80px;
          text-align-last: justify;
          color: #61666c;
          font-weight: 500;
        }
        .right-txt {
          width: ~"calc(100% - 85px)";
        }
      }
      .info-title {
        padding-left: 0;
        padding-right: 0;
        margin: 0 12px;
        border-bottom: 0.5px solid #cccccc;

        align-items: baseline;
        justify-content: space-between;
        .inner-row {
          align-items: baseline;
        }
        .info-left {
          max-width: ~"calc(100% - 120px)";
          font-size: 14px;
          font-weight: 500;
          color: rgba(67, 68, 70, 1);
          .icon-size {
            margin-right: 10px;
            height: 20px;
            box-sizing: border-box;
            &::before {
              font-size: 20px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .info-right {
          font-size: 14px;
          display: block;
          max-width: 130px;
          .count {
            font-size: 17px;
            margin-left: 3px;
          }
        }
      }
    }
    .body-container {
      position: relative;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
      background-size: 118px 142px;
      background-repeat: no-repeat;
      background-position: right 70%;
      background-image: url("../../lib/image/home/567.png");
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      width: 100%;
      padding: 14px 30px;
      font-size: 12px;
      color: #565656;
      height: auto;
      & {
        .item:last-child {
          margin: 0;
        }
      }
      .title {
        text-align: center;
        color: #242424;
        font-size: 16px;
      }
      .small-title {
        font-size: 14px;
        color: #565656;
      }
      .body-iamge {
        width: 100%;
        margin: 10px 0;
      }
      .item {
        margin-bottom: 10px;
      }
      .time {
        padding-left: 9px;
        letter-spacing: 1px;
      }
    }
    .contacts-title-box {
      padding-left: 12px;
      height: 50px;
      font-size: 14px;
      color: #555555;
      // justify-content: flex-start;
      .icon-size {
        margin-right: 5px;
        &::before {
          // font-size: 22px;
        }
      }
      .look-narrators {
        border: 0;
        padding: 3px 6px;
        font-size: 15px;
        color: rgba(255, 255, 255, 1);
        background: rgba(92, 162, 253, 1);
        border-radius: 3px;
      }
    }
  }

  .foot {
    background-color: #f0f1f4;
    // right: 0;
    padding: 0 14px;
    height: 40px;
    .btn {
      border: 0;
      font-size: 15px;
      color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 100%;
      // background:rgba(92,162,253,1);
      border-radius: 120px;
      background: linear-gradient(157deg, #ffa300 0%, #ff3f36 100%);
    }
  }

  .language-box {
    box-sizing: border-box;
    padding: 50px;
    flex-direction: column;
    .language {
      width: 100%;
    }
    .language-row {
      width: 100%;
      height: 40px;
    }
  }
}
</style>